import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { environment } from "../../../../environments/environment";
import { formatDateForBackend } from "../../../helpers/util";

@Injectable({
  providedIn: "root"
})
export class LaravelStatisticService {
  constructor(private httpClient: HttpClient) {}

  private get ROUTES() {
    return {
      orders: environment.baseUrl + "/api/statistics/orders", // ORDERS COUNT
      income: environment.baseUrl + "/api/statistics/income", // INCOME
      topSelling: environment.baseUrl + "/api/statistics/topSelling", // 5 TOP PRODUCTS SELLING
      flopSelling: environment.baseUrl + "/api/statistics/flopSelling", // 5 FLOP PRODUCT SELLING
      customers: environment.baseUrl + "/api/statistics/customers", // TOP CUSTOMERS
      zones: environment.baseUrl + "/api/statistics/zones" // TOP ZONES
    };
  }

  public orders(isDelivery: boolean, isTakeAway: boolean, tenant_id?: number, startDate?: Date, endDate?: Date, exportCSV: boolean = false): Observable<any> {
    let params = {
      startDate: formatDateForBackend(startDate),
      endDate: formatDateForBackend(endDate),
      isDelivery: isDelivery.toString(),
      isTakeAway: isTakeAway.toString(),
    };

    params["export"] = exportCSV;

    if (tenant_id !== undefined && tenant_id !== null) {
      params["tenant_id"] = tenant_id;
    }

    if (exportCSV) {
      return this.httpClient.get(this.ROUTES.orders, {
        params: new HttpParams({
          fromObject: params
        }), responseType: 'blob'
      });
    } else {
      return this.httpClient.get(this.ROUTES.orders, {
        params: new HttpParams({
          fromObject: params
        })
      });
    }
  }

  public income(startDate: Date, endDate: Date,  tenant_id?: number): Observable<any> {
    let params = {};
    params["startDate"] = formatDateForBackend(startDate);
    params["endDate"] = formatDateForBackend(endDate);

    if (tenant_id !== undefined && tenant_id !== null) {
      params["tenant_id"] = tenant_id;
    }
    return this.httpClient.get(this.ROUTES.income, {
      params: new HttpParams({
        fromObject: params
      })
    });
    
  }

  public topSelling(startDate?: Date, endDate?: Date,  tenant_id?: number, exportCSV: boolean = false): Observable<any> {
    let params = {
      startDate: startDate ? formatDateForBackend(startDate) : null,
      endDate: endDate ? formatDateForBackend(endDate) : null,
    };
    //console.log("Parametri inviati per topselling:", params);

    params["export"] = exportCSV;

    if (tenant_id !== undefined && tenant_id !== null) {
      params["tenant_id"] = tenant_id;
    }
    //console.log(this.ROUTES.topSelling, new HttpParams({ fromObject: params }).toString());

    if (exportCSV) {
      return this.httpClient.get(this.ROUTES.topSelling, {
        params: new HttpParams({
          fromObject: params
        }), responseType: 'blob'
      });
    } else {
      return this.httpClient.get(this.ROUTES.topSelling, {
        params: new HttpParams({
          fromObject: params
        })
      })
    }
  }

  public flopSelling(startDate: Date, endDate: Date): Observable<any> {
    return this.httpClient.get(this.ROUTES.flopSelling);
  }

  public customers(startDate: Date, endDate: Date): Observable<any> {
    return this.httpClient.get(this.ROUTES.customers);
  }

  public zones(startDate?: Date, endDate?: Date, tenant_id?: number, exportCSV: boolean = false): Observable<any> {
    let params = {
      startDate: startDate ? formatDateForBackend(startDate) : null,
      endDate: endDate ? formatDateForBackend(endDate) : null,
    };
    //console.log("Request Params:", params);

    params["export"] = exportCSV;

    if (tenant_id !== undefined && tenant_id !== null) {
      params["tenant_id"] = tenant_id;
    }

    if (exportCSV) {
      return this.httpClient.get(this.ROUTES.zones, {
        params: new HttpParams({
          fromObject: params
        }), responseType: 'blob'
      });
    } else {
      return this.httpClient.get(this.ROUTES.zones, {
        params: new HttpParams({
          fromObject: params
        })
      })
    }
  }

}
